<div class="container" #containerFechas>
  <div class="header">
    <h2>Fechas claves que debes conocer</h2>
    <p>
      A través de esta línea de tiempo, te contamos cuáles son los principales cambios que se vienen.
    </p>
  </div>

  <div class="timeline">
    <div *ngFor="let item of timelineData" class="timeline-item" [ngClass]="{ 'listo': item.status === 'listo', 'activo': item.status === 'activo' }">
      <div class="date-header">
        <img *ngIf="item.status === 'listo'" src="/assets/reforma-pensiones/bookmark_check.svg" alt="">
        <img *ngIf="item.status === 'activo'" src="/assets/reforma-pensiones/keep.svg" alt="">

        <div class="date-text">
            <p>{{ item.date.month }}</p>
            <p>{{ item.date.year }}</p>
        </div>
      </div>
      <div class="content">
        <ul>
          <li *ngFor="let point of item.content">
            <span [class.highlight-text]="point.highlighted">
              {{ point.text }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>